module.exports = __webpack_public_path__ + "media/images/menu/lepus-4befc3e51935362215553ec12e2e6100.jpg";